// extracted by mini-css-extract-plugin
export default {"ServiceCard":"ServiceCard_ServiceCard__3DX-a","ServiceCardIconWrapper":"ServiceCard_ServiceCardIconWrapper__1ueGc","ServiceCardIcon":"ServiceCard_ServiceCardIcon__q9TPQ"};